export default __webpack_public_path__ + "static/media/reactnative.93a4bdf1.png";